import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Cart from 'components/cart/Cart';
import HasPendingOrders from 'components/orders/inc/HasPendingOrders';
import CartButtons from 'components/cart/CartButtons';
import CartRelated from 'components/cart/CartRelated';
import CMSBlock from "components/cms/CMSBLock";
export default function PageCart() {
  const user = useSelector((state) => state.user);
  return (
    <div id="page-cart">
      <CMSBlock
        blockId="page-cart-header"
        titleTag="h1"
        contentsClassName="pb-5"
      />
      <div className="container py-5">
        <HasPendingOrders className="pb-5" />
        <div className="pb-3 d-flex gap-4 justify-content-end">
          <Link to="/formalities/templates" className="small text-primary">
            Ajouter une formalité
          </Link>

          <Link to="/customer/account" className="small text-primary">
            Voir mes formalités
          </Link>

        </div>
        <div className="pb-5">
          <Cart />
        </div>
        <CartButtons className="pb-5" />


        <CartRelated className="" title="Formalités qui pourraient vous intéresser" />
      </div>
    </div >
  );
}
